import type { EvaluationExam } from '@interactive-room';
import type { ExamLevelId } from '../constants/examAiParams';
import { EXAM_LEVEL_OPTIONS } from '../constants/examAiParams';
import { resolveCourseProfile } from '../courseContext';

const LEVEL_SET = new Set(EXAM_LEVEL_OPTIONS.map((o) => o.id));

function asLevel(value: unknown): ExamLevelId | undefined {
  const token = String(value ?? '')
    .trim()
    .toLowerCase();
  if (!token || !LEVEL_SET.has(token as ExamLevelId)) return undefined;
  return token as ExamLevelId;
}

/**
 * Nivel curricular para generate-inline / chat de edición.
 * Prioridad: prop → exam.level → curso vinculado → active course.
 */
export function resolveExamAiLevel(
  exam: EvaluationExam | null | undefined,
  explicitLevel?: string | null,
): ExamLevelId | undefined {
  const fromExplicit = asLevel(explicitLevel);
  if (fromExplicit) return fromExplicit;

  const fromExam = asLevel((exam as EvaluationExam & { level?: string } | null | undefined)?.level);
  if (fromExam) return fromExam;

  const course = resolveCourseProfile({
    courseId: exam?.courseId || exam?.linkedSession?.courseId || null,
  });
  return asLevel(course?.level);
}

export function resolveExamAiSubjectTag(
  exam: EvaluationExam | null | undefined,
  explicitSubject?: string | null,
): string {
  const fromExplicit = String(explicitSubject || '').trim();
  if (fromExplicit) return fromExplicit;
  return String(exam?.subjectTag || '').trim();
}
